export default {
  label: {
    id: 'confirmation_page_gift_checkbox',
    defaultMessage: 'Is this a gift?',
  },
  toastTitle: {
    id: 'confirmation_page_gift_checkbox_toast_title',
    defaultMessage: 'Thanks!',
  },
  toastDescription: {
    id: 'confirmation_page_gift_checkbox_toast_description',
    defaultMessage: 'Your answer helps us make Back Market better.',
  },
}
